/* tslint:disable */
/* eslint-disable */
/**
 * Melco ControlCenter APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlcenterMelcoModelsHoopCategory
 */
export interface ControlcenterMelcoModelsHoopCategory {
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoModelsHoopCategory
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoModelsHoopCategory
     */
    name?: string | null;
}

export function ControlcenterMelcoModelsHoopCategoryFromJSON(json: any): ControlcenterMelcoModelsHoopCategory {
    return ControlcenterMelcoModelsHoopCategoryFromJSONTyped(json, false);
}

export function ControlcenterMelcoModelsHoopCategoryFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlcenterMelcoModelsHoopCategory {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
    };
}

export function ControlcenterMelcoModelsHoopCategoryToJSON(value?: ControlcenterMelcoModelsHoopCategory | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
    };
}


